import { ApiCashInstrumentTransaction, ApiOperationBase } from 'api/rtk-api'
import { splitOnCapitals } from 'utilities/string'

function isZcbTransaction(transaction: ApiCashInstrumentTransaction) {
  return transaction.instrumentType === 'ZcbCurve'
}

export const getOperationType = (op: ApiOperationBase) => {
  const { cashTransactions, orders, type } = op
  const zcbCashTransactions = cashTransactions ? cashTransactions.filter(isZcbTransaction) : []

  if (
    type === 'ProtectedWithdrawal' ||
    type === 'ProtectedAccountClosure' ||
    type === 'AccountClosure'
  ) {
    return 'Withdrawal'
  }
  if (type === 'Dividend') {
    return 'Distribution'
  }
  if (type === 'ReinvestmentConfirmation') {
    return 'Reinvestment'
  }
  if (type === 'ProtectedSwitchOut') {
    return 'Switch Out'
  }
  if (type === 'TriggeredFeeDeduction') {
    return 'Fee Deduction'
  }
  if (type === 'Rebalancing' && !orders && zcbCashTransactions.length > 0) {
    return 'ZCB Rebalancing'
  }
  if (type === 'Rebalancing' && !orders && cashTransactions) {
    return 'Cash Rebalancing'
  }
  return splitOnCapitals(type)
}
